import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchColorDetailsWithoutId } from '../../../colorDetails/colorDetails.actions';
import { fetchHSNMaster } from '../../../hsnMaster/hsnMaster.actions';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchStyleDetailById } from '../../../styleDetail/styleDetail.actions';
import { fetchStyleMaster } from '../../../styleMaster/styleMaster.actions';
import { fetchFabricPoDetailsWithIdData } from '../../FabricPo/fabricPoDetails/fabricPoDetails.action';
import {
    fetchYarnPO,
    getSingleAllOverPrintingPoForApprovalStatus,
    getSingleCompactingPoForApprovalStatus,
    getSingleCuttingPoForApprovalStatus,
    getSingleDyeingPoForApprovalStatus,
    getSingleKnittingPoForApprovalStatus,
    getSingleStichingPoForApprovalStatus,
    getSingleYarnPoForApprovalStatus,
    getSinglefabricPoForApprovalStatus
} from '../yarnPO/yarnPO.actions';
import { YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE } from '../yarnPO/yarnPO.actionsType';
import {
    CREATE_YARN_PO_DETAILS_FAILURE,
    CREATE_YARN_PO_DETAILS_REQUEST,
    CREATE_YARN_PO_DETAILS_SUCCESS,
    CREATE_USER_FORM_YARN_PO_DETAILS,
    DELETE_YARN_PO_DETAILS_FAILURE,
    DELETE_YARN_PO_DETAILS_REQUEST,
    DELETE_YARN_PO_DETAILS_SUCCESS,
    FETCH_SINGLE_YARN_PO_DETAILS_FAILURE,
    FETCH_SINGLE_YARN_PO_DETAILS_REQUEST,
    FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS,
    FETCH_YARN_PO_DETAILS_FAILURE,
    FETCH_YARN_PO_DETAILS_REQUEST,
    FETCH_YARN_PO_DETAILS_SUCCESS,
    YARN_PO_DETAILS_USERFORM_RESET,
    UPDATE_YARN_PO_DETAILS_FAILURE,
    UPDATE_YARN_PO_DETAILS_REQUEST,
    UPDATE_YARN_PO_DETAILS_SUCCESS,
    FETCH_YARN_PO_DETAILS_BY_ID_REQUEST,
    FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS,
    FETCH_YARN_PO_DETAILS_BY_ID_FAILURE,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_FAILURE,
    FETCH_YARN_PO_PREVIOUS_LIST_REQUEST,
    FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS,
    FETCH_YARN_PO_PREVIOUS_LIST_FAILURE,
    FETCH_YARN_PO_UPDATE_LIST_REQUEST,
    FETCH_YARN_PO_UPDATE_LIST_SUCCESS,
    FETCH_YARN_PO_UPDATE_LIST_FAILURE,
    FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_REQUEST,
    FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_SUCCESS,
    FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_FAILURE,
    UPDATE_YARN_PO_REQUEST,
    UPDATE_YARN_PO_SUCCESS,
    UPDATE_YARN_PO_FAILURE,
    MILL_NAME_REQUEST,
    MILL_NAME_SUCCESS,
    MILL_NAME_FAILURE,
    UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_REQUEST,
    UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_SUCCESS,
    UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_FAILURE,
    MILL_NAME_WITHOUT_PROJECTION_REQUEST,
    MILL_NAME_WITHOUT_PROJECTION_SUCCESS,
    MILL_NAME_WITHOUT_PROJECTION_FAILURE
} from './yarnPODetails.actionsType';
import moment from 'moment';

// FETCH PROPERTY MASTER
export let fetchYarnPoDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnP0DetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_YARN_PO_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_DETAILS_BY_ID_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchYarnPoDetails = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnP0DetailsGET}`,
        responseTypeRequest: FETCH_YARN_PO_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_DETAILS_FAILURE
    };
    return axiosCall(config);
};

export let fetchYarnPODetailsGroupListDropdown = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPODetailsYarnGroupList}`,
        responseTypeRequest: FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_DETAILS_GROUP_LIST_FAILURE
    };
    return axiosCall(config);
};

// ?FldFKStyleId=1079&FldFKStyleDetailId=106&FldFkProgramCode=DYD
export let fetchYarnPOPreviousGetList = (saleId, styleId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnP0DetailsPreviousGetListGET}?FldSaleOrders=${saleId}&FldFKStyle=${styleId}&Stylewise=false`,
        responseTypeRequest: FETCH_YARN_PO_PREVIOUS_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_PREVIOUS_LIST_FAILURE
    };
    return axiosCall(config);
};

export let updateYarnPOOutStandingRemarks = (id, remarks) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.yarnPORemarksOutStandingPATCH}?FldId=${id}&FldRemarks=${remarks}`,
        responseTypeRequest: UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_REQUEST,
        responseTypeSuccess: UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_SUCCESS,
        responseTypeFailure: UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_FAILURE,
        getAllData: fetchYarnPoDetails()
    };
    return axiosCall(config);
};

export let changeYarnPOApprovalStatus = (id, status, code, navigateDetail, requestFailure, request, url, DCSelectedValue, fnCall) => {
    // console.log("code", code);
    let apiUrl = code === 'PPD' ? ConstantApi.printingDCDetailsApproveStatusChangeGET : ConstantApi.yarnP0DetailsApproveStatusChangeGET;
    let config = {
        method: 'patch',
        url: `${apiUrl}?FldId=${id}&ApprovalStatus=${status}&ProgramCode=${code}`,
        responseTypeRequest: FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_FAILURE,
        singlApiArray: [
            getSingleYarnPoForApprovalStatus(id, navigateDetail, requestFailure, request, url, DCSelectedValue, fnCall)

        ]
    };
    return axiosCall(config);
};


// create user Form
export let createYarnPODetailsUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_YARN_PO_DETAILS, payload: { key, value } });
    };
};

export let fetchYarnPOUpdateGetList = (selectedRows, totalSum, fldFKSaleOrder, fldFKStyle) => {
    // let data = JSON.stringify(selectedRows);
    let ids = selectedRows.map((ele) => ele.fldId);
    // console.log('......data', ids);
    let config = {
        method: 'post',
        // data,
        url: `${ConstantApi.yarnP0DetailsUpdateListGET}?FldId=${ids.toString()}&Weight=${totalSum}`,
        responseTypeRequest: FETCH_YARN_PO_UPDATE_LIST_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_UPDATE_LIST_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_UPDATE_LIST_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [fetchYarnPOPreviousGetList(fldFKSaleOrder, fldFKStyle)]
    };
    return axiosCall(config);
};

// CREATE PROPERTY MASTER
export let createYarnPODetails = (formData, modalClose, isStatus, selectedRows, parentId, fldFKSaleOrder, fldFKStyle, headerUserForm, isDirectDetails) => {
    let today = new Date();
    let totalSum = formData.fldQuantity;
    let data = JSON.stringify({
        fldFKPoNo: parseInt(formData.fldFKPoNo),
        fldFKSaleOrderNo: parseInt(formData.fldFKSaleOrderNo),
        fldSalesOrderNo: 'string',
        fldFKStyleNumber: parseInt(formData.fldFKStyleNumber),
        fldStyleNumber: 'string',
        fldFKAgentName: parseInt(formData.fldFKAgentName),
        fldAgentName: formData.fldAgentName,
        fldFKMillName: parseInt(formData.fldFKMillName),
        fldMillName: formData.fldMillName,
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldYarnGroup: 'string',
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldYarnType: formData.fldYarnType,
        fldYarnDescription: formData.fldYarnDescription,
        fldBagWeight: Number(formData.fldBagWeight) || 0,
        fldNoofBags: Number(formData.fldNoofBags) || 0,
        fldFKRatePerKG: Number(formData.fldFKRatePerKG) || 0,
        fldCostPerBag: Number(formData.fldCostPerBag) || 0,
        fldQuantity: Number(formData.fldQuantity) || 0,
        fldGrossValue: Number(formData.fldGrossValue) || 0,
        fldDiscountPercentage: Number(formData.fldDiscountPercentage) || 0,
        fldDiscountValue: Number(formData.fldDiscountValue) || 0,
        fldTaxableValue: Number(formData.fldTaxableValue) || 0,
        fldIGSTPercentage: Number(formData.fldIGSTPercentage) || 0,
        fldIGSTValue: Number(formData.fldIGSTValue) || 0,
        fldSGSTPercentage: Number(formData.fldSGSTPercentage) || 0,
        fldSGSTValue: Number(formData.fldSGSTValue) || 0,
        fldCGSTPercentage: Number(formData.fldCGSTPercentage) || 0,
        fldCGSTValue: Number(formData.fldCGSTValue) || 0,
        fldGSTValue: Number(formData.fldGSTValue) || 0,
        fldRemarks: formData.fldRemarks,
        fldTotalValue: Number(formData.fldTotalValue) || 0,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: 0,
        fldFKYarn: parseInt(formData.fldFKYarn),
        fldInwardQuantity: 0,
        fldCancelQuantity: 0,
        fldBalanceQuantity: Number(formData.fldQuantity) || 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        FldConsumedNoofBags: 0,
        FldIsCora: formData.fldIsCora || false,
        FldFKColor: parseInt(formData.fldFKColor) || 0,
        FldColor: formData.fldIsCora ? 'CORA' : formData.fldColor,
        fldSPRate: Number(formData.fldSPRate) || 0,
        fldRateDiff: Number(formData.fldRateDiff) || 0,
        fldFKProjectionId: formData.fldIsProjection == false ? Number(formData.fldFKProjectionId) : 0,
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.yarnPODetailsPOST}?FldPendingList=${selectedRows.map((ele) => ele.fldId).toString()}`,
        responseTypeRequest: CREATE_YARN_PO_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_YARN_PO_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_YARN_PO_DETAILS_FAILURE,
        resetFormData: isStatus ? YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE : YARN_PO_DETAILS_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchYarnPoDetailsById(parseInt(formData.fldFKPoNo)),
        singlApiArray: [
            isDirectDetails ? fetchYarnPO(
                moment(headerUserForm.startDate).format('YYYY-MM-DD'),
                moment(headerUserForm.endDate).format('YYYY-MM-DD'),
                headerUserForm.unitId || 1
            ) : fetchYarnPOPreviousGetList(fldFKSaleOrder, fldFKStyle),
            fetchYarnPOUpdateGetList(selectedRows, totalSum, fldFKSaleOrder, fldFKStyle),
            // getSingleYarnPoForApprovalStatus(parentId),

        ]
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleYarnPODetails = (id, style, SaleId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnPODetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_YARN_PO_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_YARN_PO_DETAILS_FAILURE,
        singlApiArray: [
            fetchStyleMaster(),
            fetchYarnPODetailsGroupListDropdown(),
            fetchCommonPropertyById(57),
            fetchCommonPropertyById(58),
            fetchHSNMaster(),
            fetchCommonPropertyById(22),
            fetchYarnPOPreviousGetList(SaleId, style),
            fetchStyleDetailById(style),
            fetchColorDetailsWithoutId()
        ]
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateYarnPODetails = (id, formData, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKPoNo: parseInt(formData.fldFKPoNo),
        fldPoNo: formData.fldPoNo,
        fldFKSaleOrderNo: parseInt(formData.fldFKSaleOrderNo),
        fldSalesOrderNo: 'string',
        fldFKStyleNumber: parseInt(formData.fldFKStyleNumber),
        fldStyleNumber: 'string',
        fldFKAgentName: parseInt(formData.fldFKAgentName),
        fldAgentName: 'string',
        fldFKMillName: parseInt(formData.fldFKMillName),
        fldMillName: 'string',
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldYarnGroup: 'string',
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldYarnType: formData.fldYarnType,
        fldYarnDescription: formData.fldYarnDescription,
        fldBagWeight: Number(formData.fldBagWeight),
        fldNoofBags: Number(formData.fldNoofBags),
        fldFKRatePerKG: Number(formData.fldFKRatePerKG) || 0,
        fldCostPerBag: Number(formData.fldCostPerBag) || 0,
        fldQuantity: Number(formData.fldQuantity),
        fldGrossValue: Number(formData.fldGrossValue),
        fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        fldDiscountValue: Number(formData.fldDiscountValue),
        fldTaxableValue: Number(formData.fldTaxableValue),
        fldIGSTPercentage: Number(formData.fldIGSTPercentage),
        fldIGSTValue: Number(formData.fldIGSTValue),
        fldSGSTPercentage: Number(formData.fldSGSTPercentage),
        fldSGSTValue: Number(formData.fldSGSTValue),
        fldCGSTPercentage: Number(formData.fldCGSTPercentage),
        fldCGSTValue: Number(formData.fldCGSTValue),
        fldGSTValue: Number(formData.fldGSTValue),
        fldRemarks: formData.fldRemarks,
        fldTotalValue: Number(formData.fldTotalValue),
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: parseInt(formData.fldFKStatus),
        fldFKYarn: parseInt(formData.fldFKYarn),
        fldInwardQuantity: Number(formData?.fldInwardQuantity) || 0,
        fldCancelQuantity: Number(formData?.fldCancelQuantity) || 0,
        fldBalanceQuantity: Number(formData?.fldBalanceQuantity) || 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        FldConsumedNoofBags: Number(formData.FldConsumedNoofBags),
        FldIsCora: formData.fldIsCora || false,
        FldFKColor: parseInt(formData.fldFKColor),
        FldColor: formData.fldColor,
        fldSPRate: Number(formData.fldSPRate) || 0,
        fldRateDiff: Number(formData.fldRateDiff) || 0,
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.yarnPODetailsPATCH}/${id}`,
        responseTypeRequest: UPDATE_YARN_PO_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_YARN_PO_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_YARN_PO_DETAILS_FAILURE,
        resetFormData: YARN_PO_DETAILS_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [getSingleYarnPoForApprovalStatus(parentId)],
        getAllData: fetchYarnPoDetailsById(parseInt(parentId))
    };
    return axiosCall(config);
};

export let updateYarnPODetailsWithPendingId = (id, formData, parentId, pendingId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKPoNo: parseInt(formData.fldFKPoNo),
        fldPoNo: formData.fldPoNo,
        fldFKSaleOrderNo: parseInt(formData.fldFKSaleOrderNo),
        fldSalesOrderNo: 'string',
        fldFKStyleNumber: parseInt(formData.fldFKStyleNumber),
        fldStyleNumber: 'string',
        fldFKAgentName: parseInt(formData.fldFKAgentName),
        fldAgentName: 'string',
        fldFKMillName: parseInt(formData.fldFKMillName),
        fldMillName: 'string',
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldYarnGroup: 'string',
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldYarnType: formData.fldYarnType,
        fldYarnDescription: formData.fldYarnDescription,
        fldBagWeight: Number(formData.fldBagWeight),
        fldNoofBags: Number(formData.fldNoofBags),
        fldFKRatePerKG: Number(formData.fldFKRatePerKG) || 0,
        fldCostPerBag: Number(formData.fldCostPerBag) || 0,
        fldQuantity: Number(formData.fldQuantity),
        fldGrossValue: Number(formData.fldGrossValue),
        fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        fldDiscountValue: Number(formData.fldDiscountValue),
        fldTaxableValue: Number(formData.fldTaxableValue),
        fldIGSTPercentage: Number(formData.fldIGSTPercentage),
        fldIGSTValue: Number(formData.fldIGSTValue),
        fldSGSTPercentage: Number(formData.fldSGSTPercentage),
        fldSGSTValue: Number(formData.fldSGSTValue),
        fldCGSTPercentage: Number(formData.fldCGSTPercentage),
        fldCGSTValue: Number(formData.fldCGSTValue),
        fldGSTValue: Number(formData.fldGSTValue),
        fldRemarks: formData.fldRemarks,
        fldTotalValue: Number(formData.fldTotalValue),
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: parseInt(formData.fldFKStatus),
        fldFKYarn: parseInt(formData.fldFKYarn),
        fldInwardQuantity: Number(formData?.fldInwardQuantity) || 0,
        fldCancelQuantity: Number(formData?.fldCancelQuantity) || 0,
        fldBalanceQuantity: Number(formData?.fldBalanceQuantity) || 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        FldConsumedNoofBags: Number(formData.FldConsumedNoofBags),
        FldIsCora: formData.fldIsCora || false,
        FldFKColor: parseInt(formData.fldFKColor),
        FldColor: formData.fldColor
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.yarnPODetailsWithPendingIdPATCH}/${id}?FldPendingList=${pendingId?.toString()}`,
        responseTypeRequest: UPDATE_YARN_PO_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_YARN_PO_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_YARN_PO_DETAILS_FAILURE,
        resetFormData: YARN_PO_DETAILS_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [getSingleYarnPoForApprovalStatus(parentId)],
        getAllData: fetchYarnPoDetailsById(parseInt(parentId))
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteYarnPODetails = (id, parentId, status) => {
    let config = {
        method: 'delete',

        url: `${ConstantApi.yarnPODetailsDELETE}/${id}?FldIsDeleted=${status}`,
        // url: `${ConstantApi.yarnPODetailsDELETE}/${id}`,

        responseTypeRequest: DELETE_YARN_PO_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_YARN_PO_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_YARN_PO_DETAILS_FAILURE,
        modalClose: true,
        // singlApiArray: [getSingleYarnPoForApprovalStatus(parentId)],
        getAllData: fetchYarnPoDetailsById(parseInt(parentId))
    };
    return axiosCall(config);
};

export let updateYarnPo = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.updateYarnPoAiCall}?FldId=${id}`,
        responseTypeRequest: UPDATE_YARN_PO_REQUEST,
        responseTypeSuccess: UPDATE_YARN_PO_SUCCESS,
        responseTypeFailure: UPDATE_YARN_PO_FAILURE
    };
    return axiosCall(config);
};


export let getMillNo = (id, supplierId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.millNoLists}?FldFKYarn=${id}&FldFKSupplier=${supplierId}`,
        responseTypeRequest: MILL_NAME_REQUEST,
        responseTypeSuccess: MILL_NAME_SUCCESS,
        responseTypeFailure: MILL_NAME_FAILURE
    };
    return axiosCall(config);
};

export let getMillNoWithoutProjection = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.millNoLists}?FldFKYarn=${id}`,
        responseTypeRequest: MILL_NAME_WITHOUT_PROJECTION_REQUEST,
        responseTypeSuccess: MILL_NAME_WITHOUT_PROJECTION_SUCCESS,
        responseTypeFailure: MILL_NAME_WITHOUT_PROJECTION_FAILURE
    };
    return axiosCall(config);
};

